// src/app/routes.tsx
import { Suspense, lazy } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import RequireAuth from './RequireAuth'
import PublicOnly from './PublicOnly'
import AppLayout from '../layout/AppLayout'
import { APP_SECTION_ROUTES } from '../routes/app'

// lazy pages
const Home = lazy(() => import('../pages/Home'))
const Faq = lazy(() => import('../pages/Faq'))
const Blog = lazy(() => import('../pages/Blog'))
const Contact = lazy(() => import('../pages/Contact'))
const Login = lazy(() => import('../pages/Login'))
const Logout = lazy(() => import('../pages/Logout'))
const Success = lazy(() => import('../pages/Success'))
const Cancel = lazy(() => import('../pages/Cancel'))
const Quiz = lazy(() => import('../pages/Quiz'))
const QuizzesPage = lazy(() => import('../pages/QuizzesPage'))
const Uitslag = lazy(() => import('../pages/Uitslag'))
const Privacy = lazy(() => import('../pages/Privacy'))
const Voorwaarden = lazy(() => import('../pages/Voorwaarden'))
const Cadeaubon = lazy(() => import('../pages/Cadeaubon'))
const Checkout = lazy(() => import('../pages/Checkout'))

function RouteLoader() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center text-gray-600 dark:text-neutral-300">
      Laden…
    </div>
  )
}

export default function AppRoutes() {
  return (
    <Suspense fallback={<RouteLoader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/voorwaarden" element={<Voorwaarden />} />

        <Route path="/cadeaubon" element={<Cadeaubon />} />
        <Route path="/checkout" element={<Checkout />} />

        <Route path="/inloggen" element={<PublicOnly><Login /></PublicOnly>} />
        <Route path="/uitloggen" element={<Logout />} />

        <Route
          path="/quiz"
          element={
            <RequireAuth>
              <Quiz />
            </RequireAuth>
          }
        />

        <Route
          path="/quizzes"
          element={
            <RequireAuth>
              <QuizzesPage />
            </RequireAuth>
          }
        />

        <Route
          path="/app"
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route path="uitslag" element={<Uitslag />} />
          {APP_SECTION_ROUTES}
        </Route>

        <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
